import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import MainPagetitle from '../../layouts/MainPagetitle';
import BathroomService from '../../api/services/BathroomService';

const AddBathroomManagement = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState()
  const [error, setError] = useState("")
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var icon = fileReader.result
      setFile(icon)
    }
  }
  const onSubmitForm = async (event) => {
    event.preventDefault();
    try {
      var userData = {
        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
        "icon": file ? file.split(',')[1] : "",
      }
      let responseData = await BathroomService.store(userData).json()
      if (responseData.status === true) {

        navigate("/admin/bathroom_management");
      }
    } catch (error) {
      console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };

  return (
    <>
      <MainPagetitle mainTitle="Bathroom" pageTitle={'Bathroom'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Bathroom</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmitForm}>
                  <div className="row">
                    <h5 style={{ color: 'red' }}>{error}</h5>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Icon <span className="text-danger">*</span></label>
                      <img className="img-drop-area" height={file ? 100 : 0} width={file ? 100 : 0} src={file} alt='' />
                      <input type="file" className="form-control" name='icon' id="val-number" accept="image/png, image/jpeg, image/svg+xml" onChange={onFileChange} />
                    </div>
                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                    {/* <Link to={"#"} onClick={()=>setAddEmploye(false)} className="btn btn-danger light ms-1">Cancel</Link> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};
export default AddBathroomManagement;